"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeight = exports.font = exports.StyledMapContainer = exports.StyledError = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var font = "font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Nota Sans\", sans-serif";
exports.font = font;
var fontWeight = "font-weight: 600;";
exports.fontWeight = fontWeight;
var StyledMapContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    border-radius: ", ";\n\n    & > div {\n        border-radius: ", ";\n        -webkit-transform: translateZ(0);\n    }\n"])), function (props) {
  return props.rounded ? props.rounded : "";
}, function (props) {
  return props.rounded ? props.rounded : "";
});
exports.StyledMapContainer = StyledMapContainer;
var StyledError = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 17px;\n    letter-spacing: -0.022em;\n    line-height: 1.47059;\n"])), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : 600;
});
exports.StyledError = StyledError;